import React, { Component } from 'react';
import Select from 'react-select';
import moment from 'moment';
import axios from 'axios';
import 'moment/locale/pt';

import PdfUTIProbabilidadeInternacao from './components/PdfUTIProbabilidadeInternacao';
import InsightcareLocalFooter from './components/InsightcareLocalFooter';
import InsightcareHeader from './components/InsightcareHeader';
import ProgressBar from './components/Progress';
import Loading from './components/Loading';

import AuxRoutines from './AuxRoutines';
import { BACKEND_INS_URL } from './config/constants';
class PainelUTIProbabilidadeInternacao extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    this.state = {
      cycle: 0,
      loading: true,
      totalCycles: 0,
      pacientes: [],
      serachPacientes: [],
      filteredPacientes: [],
      numberOfElements: 0,
      sigla: params.sigla ?? '',
      idsLocais: params.locais,
      theme: (params.theme === 'dark' ? 'dark' : 'light'),
      iconText: (params.theme === 'dark' ? '_dark' : ''),
      locationName: AuxRoutines.getLocationName(params.base, params.company, BACKEND_INS_URL),
      boolFoward: 1,
      boolPause: 0,
      interval: 0,
      intervalValue: 0,
      value: 0,
    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
  }

  componentDidMount() {
    //Carrega o local se existe
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
    if (this.state.theme === 'dark') {
      document.body.style.backgroundColor = "black";
    }
    this.moveProgress();
    this.loadRequiredData().then(() => {
      this.setState({ appIsReady: true });
    });
  }

  async loadingBar(time) {
    return await new Promise(resolve => {
      this.setState({
        intervalValue: setInterval(async () => {
          resolve('load');
          const newValue = this.state.value + 1;
          if (newValue <= 100 && this.state.boolPause === 0 && this.state.filteredPacientes.length !== 1) {
            this.setState({
              value: newValue,
            });
          }
        }, time),
      });
    });
  }

  moveProgress() {
    clearInterval(this.state.interval);
    clearInterval(this.state.intervalValue);
    if (this.state.boolPause === 0) {
      this.loadingBar(200).then(() => { console.log('loading') });
      this.setState({
        interval: setInterval(async () => {
          this.setState({
            value: 0,
          });
          this.loadRequiredData();
        }, 20000),
      });
    }
  }

  pauseProgress() {
    clearInterval(this.state.intervalValue);
    clearInterval(this.state.interval);
  }

  async loadRequiredData() {
    let sliceSize = 8;

    moment.locale('pt');
    if (this.state.cycle === this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle = 1;
      let totalCycles = Math.ceil(numberOfElements / sliceSize);
      if (totalCycles === 0) {
        cycle = 0;
      }

      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    } else {
      if (this.state.totalCycles > 0) {
        this.setState({ cycle: this.state.cycle + 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * this.state.cycle), sliceSize + (sliceSize * this.state.cycle)) })
      }
    }
  }

  changeCycle(boolFoward) {
    let sliceSize = 8;
    if (boolFoward === 0) {
      if (this.state.cycle === 1) {
        this.setState({ cycle: this.state.totalCycles, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.totalCycles - 1)), sliceSize + (sliceSize * (this.state.totalCycles - 1))) })
      } else {
        this.setState({ cycle: this.state.cycle - 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.cycle - 2)), sliceSize + (sliceSize * (this.state.cycle - 2))) })
      }
    } else if (boolFoward === 1) {
      this.loadRequiredData();
    }
    this.setState({
      value: 0,
    });
  }

  actionPause(boolPause) {
    if (boolPause === 0) {
      this.setState({ boolPause: 1 }, () => {
        this.pauseProgress();
      });
    }
    if (boolPause === 1) {
      this.setState({ boolPause: 0 }, () => {
        this.moveProgress();
      });
    }
  }

  async requestData() {
    let returnData = this.state.pacientes; //In case request fails
		let url = BACKEND_INS_URL + '/mon-pacientes-atendimento/list-probabilidade-internacao?sharedSecret=hd783g4kshd7f9fhalu&token=hgoDjUMCQh67e6WviiK0KuiDt8UxNI&idtipo=2';
    if (this.state.idsLocais !== undefined && this.state.idsLocais !== 'all') {
      url = url + '&locais=' + this.state.idsLocais;
    }

    let response = await axios.get(url);
    if (response.data && response.data.Status === true) {
      returnData = response.data.ReturnData.Pacientes;
    }

    this.setState({
      serachPacientes: returnData,
      filteredPacientes: this.state.filteredPacientes === 1 ? this.state.filteredPacientes : returnData,
    });

    return returnData;
  }

  getTempoAtendimentoFormatado(valor) {
    let _tempo = valor.toString();
    if (valor <= 60) {
      _tempo = _tempo + ' mins';
    } else {
      if (valor <= 1440) {
        _tempo = Math.trunc(valor / 60).toString() + ' horas';
      } else {
        _tempo = Math.trunc(valor / 1440).toString() + ' dias';
      }
    }
    return _tempo;
  }

  textoGrupoPacientes(ciclo, totalCiclos, totalElementos) {
    if (this.state.filteredPacientes.length === 1) {
      return "Mostrando de 1 a 1, de 1 paciente";
    }
    else {
      var de = (ciclo <= 1) ? ciclo : (ciclo - 1) * 8;
      var ate = (ciclo === totalCiclos) ? totalElementos : ciclo * 8;
      return "Mostrando de " + de + " a " + ate + ", de " + totalElementos + " pacientes";
    }
  }

  changeTheme() {
    this.setState({ loading: true });
    this.setState(prevState => ({
      theme: prevState.theme === 'light' ? 'dark' : 'light',
    }));
    var $path = '/painel/uti-probabilidade-internacao';
    if (this.state.idsLocais !== undefined && this.state.idsLocais !== 'all') {
      $path = $path + '/' + this.state.idsLocais;
    } else {
      $path = $path + '/all';
    }
    if (this.state.theme === 'light') {
      $path = $path + '/dark';
    }
    window.location.href = $path;
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    const loading = this.state.loading;
    const theme = this.state.theme;
    return (
      <div className={"App " + theme}>
        {
          loading
            ? (<Loading />)
            : (
              <div>
                <InsightcareHeader title={"Probabilidade de UTI "} theme={theme} />
                <main className={"content " + theme} id="panel1Styled">
                  <ProgressBar value={this.state.value} max={100} theme={theme}/>
                  <div className={"inforow " + theme}>
                    <div className={'inforow right ' + theme}>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(0)} ><img src={"/img/icon_arrow_left" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(1)}><img src={"/img/icon_arrow_right" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.actionPause(this.state.boolPause)} ><img src={(this.state.boolPause === 1 ? "/img/icon_play" : "/img/icon_pause") + this.state.iconText + ".svg"} alt="" /></button>
                      <div className='infoText'>{this.textoGrupoPacientes(this.state.cycle, this.state.totalCycles, this.state.numberOfElements)}</div>
                    </div>
                    <div className={'inforow left ' + theme}>
                      <div className='infoText'>Agora são {this.state.currentDateHour}</div>
                      <PdfUTIProbabilidadeInternacao title={"Probabilidade de UTI "} list={(this.state.filteredPacientes.length === 0) ? this.state.serachPacientes : this.state.filteredPacientes} theme={theme} />
                      <form>
                        <div className={'buttonSearch ' + theme}>
                          <img src={"/img/icon_search" + this.state.iconText + ".svg"} alt="" />
                          <Select className={'selectSearch ' + theme}
                            placeholder="Busque por um paciente ou atendimento..."
                            options={
                              this.state.serachPacientes.map(opt => ({
                                key: opt.codigoatendimento,
                                label: opt.nomepaciente + " \n(" + opt.codigoatendimento + ")",
                                value: opt.codigoatendimento,
                                nome: opt.nomepaciente,
                                codAtendimento: opt.codigoatendimento,
                              }))}
                            onFocus={opt => {
                              this.actionPause(0);
                            }}
                            onBlur={opt => {
                              this.actionPause(1);
                            }}
                            isClearable={true}
                            onChange={opt => {
                              if (opt !== null && opt !== '') {
                                const pessoa = this.state.serachPacientes.find((elem) => (elem.nomepaciente === opt.nome || elem.codigoatendimento === opt.codAtendimento));
                                if (pessoa) {
                                  this.setState({
                                    filteredPacientes: [pessoa]
                                  });
                                } else {
                                  this.setState({
                                    filteredPacientes: this.state.serachPacientes,
                                  });
                                }
                              } else {
                                this.setState({
                                  filteredPacientes: this.state.serachPacientes,
                                });
                              }
                            }}
                          />
                        </div>
                      </form>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeTheme()}><img src={"/img/icon_theme" + this.state.iconText + ".svg"} alt="" /></button>
                    </div>
                  </div>

                  <table className={'table table-striped' + (theme === 'dark' ? '-dark' : '')}>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Atendimento</th>
                        <th>Paciente</th>
                        <th>Local</th>
                        <th>Setor</th>
                        <th>Especialidade </th>
                        <th>Probabilidade</th>
                      </tr>
                    </thead>
                    <tbody className={theme}>
                      {
                        (this.state.filteredPacientes.length === 1
                          ? this.state.filteredPacientes
                          : this.state.pacientes)
                          .map((data) => {
                            let color = '';
                            let colorProbabilidade = '';
                            let statusClass = "ready";
														let situacao = data.previsaouti + ' %';
                            let tdClassFarm = "";
                            let spanClassFarm = "";
                            let nascimento = moment(data.nascimentopaciente).format('DD/MM/YYYY');
                            let name = data.nomepaciente.split(' ').slice(-1).join(' ') + ', ' + data.nomepaciente.split(' ')[0].slice(0, 1);
														if (this.state.locationName == 'Amaral Carvalho') {
															name = data.nomepaciente;
														}
                            let codAtendimento = data.codigoatendimento;
                            let especialidade = data.descricaoespecialidade;
                            let local = data.local;
                            let setor = data.descricaosetor;
                            let key = "tr-" + data.codigoatendimento;

                            if (data.previsaouti <= 25) {
                              colorProbabilidade = '#888888';
                              statusClass = "scheduled";
                            } else if (data.previsaouti > 25 && data.previsaouti <= 50) {
                              statusClass = 'waiting';
                              colorProbabilidade = '#ff771d';
                            } else if (data.previsaouti > 50) {
                              statusClass = 'canceled';
                              colorProbabilidade = '#cc0000';
                            } else {
                              statusClass = "progress";
                            }

                            return (
                              <tr key={key} className={statusClass}>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} className='alert-content'> <div className="alert-label" /></td>
                                <td style={{ color: color }} align="left">{codAtendimento}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='infoText'><b>{name}</b> | {nascimento}  </td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{local}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{setor}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{especialidade}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: colorProbabilidade }} align="left"><b>{situacao}</b> </td>
                              </tr>
                            )
                          })
                      }
                    </tbody>
                  </table>
                </main>
                <InsightcareLocalFooter hospitalName={this.state.locationName} theme={theme} />
              </div>
            )
        }
      </div>
    );
  }
}

export default PainelUTIProbabilidadeInternacao;
